export default __webpack_public_path__ + "static/media/game.b2d16f82.jpg";